import React, { Component } from 'react';
import { Alert } from 'reactstrap';

class QuestionField extends Component {
  render() {
    let colSize = this.props.colsize ? this.props.colsize : 12;
    return (
      <Alert color="warning" xs={colSize} className="tempAlert">
        :( Issue #{this.props.qNum}: {this.props.prob} :(
      </Alert>
    );
  }
}

export default QuestionField;



// WEBPACK FOOTER //
// ./src/components/QuestionField.js